module.exports = __webpack_public_path__ + "static/media/DOC.065eff69.svg";